import { useState, useEffect } from "react";
import { SegnalazioneLight } from "../../../services/models/objs/SegnalazioneLight";
import CustomDeleteIconButton from "../../../shared/atomic_components/button/CustomDeleteIconButton";
import { SegnalazioniService } from "../../../services/controllers/segnalazioni-services/SegnalazioniService";
import User from "../../../services/models/output-objs/User";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css"; 
import "./SegnalazioniTableGrid.css"
import { ColDef, ICellRendererParams, ValueGetterParams, } from "ag-grid-community";
import {AG_GRID_LOCALE_IT} from "@ag-grid-community/locale";
import CONSTANTS from "../../../shared/utils/Constants";
import CustomRectifyIconButton from "../../../shared/atomic_components/button/CustomRectifyIconButton";
import CustomRefreshIconButton from "../../../shared/atomic_components/button/CustomRefreshIconButton";
import StorBeFeParser from "../../../shared/utils/storBeFeParser";
import { Checkbox } from "@mui/material";

type SegnalazioniTableType = {
    elements : SegnalazioneLight[]
    user : User
    deleteCallBack: (currentSegnalazione: SegnalazioneLight) => void;
    orderCallBack: (parameter : string, order: string) => void;

}

const SegnalazioniTableGrid = ({elements,user,deleteCallBack, orderCallBack} : SegnalazioniTableType) => {


    useEffect(() => {
        setRowData(elements)
    }, [elements])

    const segnalazioniService : SegnalazioniService = new SegnalazioniService();
    const [rowData, setRowData] = useState<SegnalazioneLight[]>(elements);

    const defaultColDef: ColDef = {
        resizable: false
    };

    // Column Definitions: Defines & controls grid columns.
    const [colDefsInt] = useState<ColDef<SegnalazioneLight>[]>([
        {
        headerName: 'Demaco',
        width: 100,
        cellRenderer: (params:any) => {
            const checked= params.data.demacoAssigned;
            const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
                const newValue = e.target.checked;
                try {
                        await segnalazioniService.changeFlagDemaco(params.data.id, newValue);
                        params.data.demacoAssigned = newValue;
                        params.api.refreshCells({ rowNodes: [params.node] });
                    } catch (err) {
                        console.error('Errore aggiornando demacoAssigned:', err);
                    }
                };
                return (
                    <Checkbox
                        checked={checked}
                        onChange={handleChange}
                        className="cursor-pointer"
                    />
                );
            },
        },
        { headerName: 'Identificativo', onCellClicked(event) {
            if(event && event.data) goToStorDetailPage(event.data.id)
        }, width:150, valueGetter: (p: ValueGetterParams) => p.data.id},
        { headerName: 'Protcollo Consob', onCellClicked(event) {
            if(event && event.data) goToStorDetailPage(event.data.id)
        }, width:150, valueGetter: (p: ValueGetterParams) => p.data.protocolNumber},
        { headerName: 'Soggetto Segnalante', width:200, onCellClicked(event) {
            if(event && event.data) goToStorDetailPage(event.data.id)
        }, valueGetter: (p: ValueGetterParams) => p.data.reportingSubject},
        { headerName: 'Data Invio', onCellClicked(event) {
            if(event && event.data) goToStorDetailPage(event.data.id)
        }, width:150, comparator:(date1,date2)=>{
            const parseDate = (str:any)=>{
                if(!str) return 0;
                const [day,month,year] = str.split('/').map(Number);
                return new Date(year,month -1, day).getTime();
            };
            return parseDate(date1)-parseDate(date2);
        }, valueGetter: (p: ValueGetterParams) => p.data.sentDate},
        { headerName: 'Tipo', onCellClicked(event) {
            if(event && event.data) goToStorDetailPage(event.data.id)
        }, width:150, valueGetter: (p: ValueGetterParams) => (p.data.type !== 'Other Inputs')? p.data.type  : 'ALTRO'},
        { headerName: 'Strumento Finanziario', onCellClicked(event) {
            if(event && event.data) goToStorDetailPage(event.data.id)
        }, width:200, valueGetter: (p: ValueGetterParams) => p.data.financialString},
        { headerName: 'Tipologia Abuso', onCellClicked(event) {
            if(event && event.data) goToStorDetailPage(event.data.id)
        }, width:200, valueGetter: (p: ValueGetterParams) => p.data.suspicionType},
        { headerName: 'Stato', onCellClicked(event) {
            if(event && event.data) goToStorDetailPage(event.data.id)
        }, width:150, valueGetter: (p: ValueGetterParams) => p.data.state},
        { headerName: 'Line of Inquiry', onCellClicked(event) {
            if(event && event.data) goToStorDetailPage(event.data.id)
        }, width:200, valueGetter: (p: ValueGetterParams) => p.data.lineOfInquiry},
        { headerName: 'Livello', onCellClicked(event) {
            if(event && event.data) goToStorDetailPage(event.data.id)
        }, width:150, valueGetter: (p: ValueGetterParams) => p.data.livello},
        { headerName: 'Score', onCellClicked(event) {
            if(event && event.data) goToStorDetailPage(event.data.id)
        }, width:150, valueGetter: (p: ValueGetterParams) => p.data.score},
        { headerName: 'Score Loi', onCellClicked(event) {
            if(event && event.data) goToStorDetailPage(event.data.id)
        }, width:150, valueGetter: (p: ValueGetterParams) => p.data.lineOfInquiryScore},
        { headerName: 'Leader', onCellClicked(event) {
            if(event && event.data) goToStorDetailPage(event.data.id)
        }, width:200, valueGetter: (p: ValueGetterParams) => getFunzionarioLeader(p.data)},
        { headerName: 'Referenti', onCellClicked(event) {
            if(event && event.data) goToStorDetailPage(event.data.id)
        }, width:250, valueGetter: (p: ValueGetterParams) => getFunzionario(p.data)},
        { headerName: 'Esito Proposto', onCellClicked(event) {
            if(event && event.data) goToStorDetailPage(event.data.id)
        }, width:150, valueGetter: (p: ValueGetterParams) => p.data.esitoProposto},
        { headerName: '', pinned:"left", width:100, 
            cellRenderer: (params:ICellRendererParams<SegnalazioneLight>)=>{
                if(params.data)
                    return returnButton(params)
                else
                    return undefined
            }
        },
    ]);

    const [colDefsExt] = useState<ColDef<SegnalazioneLight>[]>([
        { headerName: 'Protocollo Interno', onCellClicked(event) {
            if(event && event.data) goToStorDetailPage(event.data.id)
        }, width:150, valueGetter: (p: ValueGetterParams) => p.data.externalProtocolNumber},
        { headerName: 'Protcollo Consob', onCellClicked(event) {
            if(event && event.data) goToStorDetailPage(event.data.id)
        }, width:150, valueGetter: (p: ValueGetterParams) => p.data.protocolNumber},
        { headerName: 'Soggetto Segnalante', onCellClicked(event) {
            if(event && event.data) goToStorDetailPage(event.data.id)
        }, width:200, valueGetter: (p: ValueGetterParams) => p.data.reportingSubject},
        { headerName: 'Data Invio', onCellClicked(event) {
            if(event && event.data) goToStorDetailPage(event.data.id)
        }, width:150, comparator:(date1,date2)=>{
            const parseDate = (str:any)=>{
                if(!str) return 0;
                const [day,month,year] = str.split('/').map(Number);
                return new Date(year,month -1, day).getTime();
            };
            return parseDate(date1)-parseDate(date2);
        }, valueGetter: (p: ValueGetterParams) => p.data.sentDate},
        { headerName: 'Tipo', onCellClicked(event) {
            if(event && event.data) goToStorDetailPage(event.data.id)
        }, width:150, valueGetter: (p: ValueGetterParams) => (p.data.type !== 'Other Inputs')? p.data.type  : 'ALTRO'},
        { headerName: 'Strumento Finanziario', onCellClicked(event) {
            if(event && event.data) goToStorDetailPage(event.data.id)
        }, width:200, valueGetter: (p: ValueGetterParams) => p.data.financialString},
        { headerName: 'Tipologia Abuso', onCellClicked(event) {
            if(event && event.data) goToStorDetailPage(event.data.id)
        }, width:250, valueGetter: (p: ValueGetterParams) => p.data.suspicionType},
        { headerName: 'Stato', onCellClicked(event) {
            if(event && event.data) goToStorDetailPage(event.data.id)
        }, width:150, valueGetter: (p: ValueGetterParams) => p.data.state},
        { headerName: '', pinned:"left",  width:100,
            cellRenderer: (params:ICellRendererParams<SegnalazioneLight>)=>{
                if(params.data)
                    return returnButton(params)
                else
                    return undefined
            }
        },
    ]);

    const pagination = true;
    const paginationPageSize = 30;
    const paginationPageSizeSelector = [30, 100, 200, 500];
    const localeText = AG_GRID_LOCALE_IT;

    const onColumnMoved = (params:any) =>{
        const sortModel = params.api.getColumnState()
        const sortState = sortModel.filter(function (s:any){
            return s.sort!=null
        }).map(function(s:any){
            return {colId:s.colId, sort:s.sort, sortIndex:s.sortIndex}
        })
        sessionStorage.setItem('tableSort',JSON.stringify(sortState))
    }

    const onGridReady = (params:any)=>{
        const orderSaved = JSON.parse(sessionStorage.getItem('tableSort') || '')
        if(orderSaved){
            params.api.applyColumnState({
                state:orderSaved,
            })
        }
    }

    function submitDeleteStor(submitted: boolean, currentSegnalazione?: SegnalazioneLight){
        if(submitted && currentSegnalazione){
            deleteCallBack(currentSegnalazione);
        }
    }


    function returnButton(p: any){
        return(
            <div>
                {((p.data.state === 'Inviata' || p.data.state === 'Da completare') && p.data.owner && user.selectedGroup!=='revisore')?
                    <CustomRectifyIconButton title={'Integra Segnalazione'} idSegnalazione={p.data.id} user={user}>
                    </CustomRectifyIconButton> : <></>
                }
                {((p.data.state === 'Inviata' || p.data.state === 'Da completare') &&  p.data.owner && user.selectedGroup!=='revisore') ?
                    <CustomRefreshIconButton title={'Ricarica'} idSegnalazione={p.data.id} currentSegnalazione={p.data} user={user}>
                    </CustomRefreshIconButton> : <></>
                }
                {(p.data.state === 'In compilazione' &&  p.data.owner && user.selectedGroup!=='revisore')?
                    <CustomDeleteIconButton title={'Cancella Segnalazione'}
                        modalTitle={'Elimina la segnalazione'}
                        modalBody={'Confermando cancellerai la segnalazione, sicuro di voler procedere?'}
                        currentSegnalazione={p.data}
                        onCallBack={(submitted: boolean, currentSegnalazione?: SegnalazioneLight) => submitDeleteStor(submitted, currentSegnalazione)}
                    /> : <></>
                }
            </div>
        )
    }

    function getFunzionarioLeader(currentSegnalazione?: SegnalazioneLight ){
        let funzName = ''
        if(currentSegnalazione && currentSegnalazione.funzionari && currentSegnalazione.funzionari.length>0){
            currentSegnalazione.funzionari.map((singleFunz : any) =>{
                if(singleFunz.assignmentType && singleFunz.assignmentType.id === 1)
                    funzName =  singleFunz.storOfficerId.cognome
            })
        }
        return funzName
    }

    function getFunzionario(currentSegnalazione?: SegnalazioneLight ){
        let funzName = ''
        if(currentSegnalazione && currentSegnalazione.funzionari && currentSegnalazione.funzionari.length>0){
            currentSegnalazione.funzionari.map((singleFunz : any) =>{
                if(singleFunz.assignmentType && singleFunz.assignmentType.id !== 1)
                    if(funzName === '')
                        funzName =  singleFunz.storOfficerId.cognome
                    else
                        funzName += ',' + singleFunz.storOfficerId.cognome
            })
        }
        return funzName
    }

    async function goToStorDetailPage(idSegnalazione : string) {
        sessionStorage.setItem('arrivedFromSegnalazioneCreate', 'false')
        sessionStorage.setItem('idSegnalazione', idSegnalazione)
        getStorByIDEffect()
    }

    async function getStorByIDEffect(){
        const response = await segnalazioniService.getStorByID(sessionStorage?.getItem('idSegnalazione') || '');
        if (response){
            const parsedSegnalazione = await StorBeFeParser.parseBetoFe(response)
            sessionStorage.setItem('idSegnalazioneCreazione', parsedSegnalazione?.systemInformations?.id || '')
            sessionStorage.setItem('segnalazioneGetStorById', JSON.stringify(parsedSegnalazione))
            sessionStorage.setItem('extraInfo', JSON.stringify(response.extraInfo) || '')
            window.location.href = '/stor-fe/stor/detail';
        }
    }

    return (
        <div>
            {user?.ldapSource?.toLowerCase().includes(CONSTANTS.internalUserRole) ?
                <div className="ag-theme-quartz-dark mt-3" style={{height: '500px', width: '100%'}}>
                    <AgGridReact 
                        rowData={rowData} 
                        columnDefs={colDefsInt}
                        defaultColDef={defaultColDef} 
                        pagination={pagination}
                        paginationPageSize={paginationPageSize}
                        paginationPageSizeSelector={paginationPageSizeSelector}
                        localeText={localeText}
                        onSortChanged={onColumnMoved}
                        onGridReady={onGridReady}
                    />
                </div>
                :
                <div className="ag-theme-quartz-dark mt-3" style={{height: '500px', width: '100%'}}>
                    <AgGridReact 
                        rowData={rowData} 
                        columnDefs={colDefsExt}
                        defaultColDef={defaultColDef} 
                        pagination={pagination}
                        paginationPageSize={paginationPageSize}
                        paginationPageSizeSelector={paginationPageSizeSelector}
                        localeText={localeText}
                        onSortChanged={onColumnMoved}
                        onGridReady={onGridReady}
                    />
                </div>
            }
        </div>
    );

}

export default SegnalazioniTableGrid
